<template>
  <div id="navbar">
    <v-app-bar color="#0E091F" dark flat fixed>
      <v-toolbar-title id="title" class="ml-10"
        >TheKitty<span style="color: #d9ad59">Club</span>.</v-toolbar-title
      >

      <v-spacer></v-spacer>

      <div id="links" class="mr-10">
        <a href="#join-now-page">Home</a>
        <a href="#what-is-kitty-club-page">What is Kitty Club ?</a>

        <a href="#benefits-page">Benefits & utilities</a>
        <a href="#discover-page">The legendaries</a>
        <a href="#roadmap-page">Roadmap</a>
        <a href="#team-page">The Team</a>
        <a href="#faq-page">FAQ</a>
      </div>
      <div class="mr-10">
        <a
          ><v-icon class="icon-navbar" color="#D9AD59"> mdi-twitter </v-icon></a
        >
        <a
          ><v-icon color="#D9AD59" class="ml-2 icon-navbar">
            mdi-discord
          </v-icon></a
        >
        <a
          ><v-icon color="#D9AD59" class="ml-2 icon-navbar">
            mdi-instagram
          </v-icon></a
        >
      </div>
      <a href="#" id="btn-navbar" class="glow-button">Mint now</a>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        id="navicon"
      ></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer
      id="drawer"
      v-model="drawer"
      temporary
      color="#0e091f"
      dark
      app
    >
      <v-list nav dense>
        <v-list-item-group v-model="group">
          <v-list-item>
            <v-list-item-title
              ><a id="list-link" href="#join-now-page"
                >Home</a
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item>
            <v-list-item-title
              ><a id="list-link" href="#what-is-kitty-club-page"
                >What is Kitty Club ?</a
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item>
            <v-list-item-title
              ><a id="list-link" href="#benefits-page"
                >Benefits & utilities</a
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item>
            <v-list-item-title
              ><a id="list-link" href="#discover-page"
                >The legendaries</a
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item>
            <v-list-item-title
              ><a id="list-link" href="#roadmap-page"
                >Roadmap</a
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item>
            <v-list-item-title
              ><a id="list-link" href="#team-page"
                >The Team</a
              ></v-list-item-title
            >
          </v-list-item>
          <v-list-item>
            <v-list-item-title
              ><a id="list-link" href="#faq-page">FAQ</a></v-list-item-title
            >
          </v-list-item>
          <div class="text-center">
            <a href="#" class="glow-button">Mint now</a>
            <div class="mt-5">
              <a
                ><v-icon id="icons" medium color="#D9AD59">
                  mdi-twitter
                </v-icon></a
              >
              <a
                ><v-icon medium color="#D9AD59" class="ml-2">
                  mdi-discord
                </v-icon></a
              >
            </div>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  name: "NavBar",

  data() {
    return {
      drawer: false,
      group: null,
    };
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
};
</script>
<style>
.v-toolbar__content {
  height: 80px !important;
}
</style>
<style scoped>
#icons {
  bottom: 0 !important;
}
#list-link {
  text-decoration: none;
  color: white !important;
}
.v-app-bar {
  height: 80px !important;
}
#navbar {
  z-index: 20;
}

#links a:target {
  padding: 80px;
}
#links a {
  text-decoration: none;
  color: white !important;
  font-weight: 300;
  margin-left: 1.5vw;
  font-size: 1vw;
  scroll-margin-top: 80px;
}

.glow-button {
  text-decoration: none;
  color: white !important;
  background: linear-gradient(
    135deg,
    rgba(217, 173, 89, 1) 0%,
    rgba(162, 128, 62, 1) 100%
  );
  padding: 10px 30px;
  border-radius: 4px;
  font-weight: normal;
  box-shadow: 0 0 15px rgb(255, 255, 255, 0.4) !important;
  cursor: pointer;
}
#navicon {
  display: none;
}
@media screen and (max-width: 960px) {
  #links a,
  #btn-navbar,
  .icon-navbar {
    display: none !important;
  }
  #links a {
    display: none;
  }
  #navicon {
    display: block;
  }
  #title {
    margin-left: 6px !important;
  }
  #navbar {
    margin-bottom: 56px;
  }
}
</style>
